import { ArrowUp, Minus, ArrowDown } from "lucide-react";
import { Badge } from "@/components/ui/badge";

// Traffic-light order: never rely on color alone — every badge pairs the hue
// with an icon and the label text, per the palette's accessibility rule.
export const PRIORITIES = ["high", "medium", "low"];

export const PRIORITY_CONFIG = {
  high: {
    label: "High", icon: ArrowUp,
    badge: "bg-fun-red-tint text-fun-red", dot: "bg-fun-red", border: "border-l-fun-red",
  },
  medium: {
    label: "Medium", icon: Minus,
    badge: "bg-fun-yellow-tint text-fun-yellow", dot: "bg-fun-yellow", border: "border-l-fun-yellow",
  },
  low: {
    label: "Low", icon: ArrowDown,
    badge: "bg-fun-green-tint text-fun-green", dot: "bg-fun-green", border: "border-l-fun-green",
  },
};

export function PriorityBadge({ priority }) {
  const cfg = PRIORITY_CONFIG[priority] || PRIORITY_CONFIG.medium;
  const Icon = cfg.icon;
  return (
    <Badge className={`gap-1 rounded-full ${cfg.badge}`}>
      <Icon className="h-3 w-3" /> {cfg.label}
    </Badge>
  );
}
